import { useMutation, useQuery } from 'react-query';
import { TaskService } from '@api/TaskService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
// Records
const useListTask = (
  [id, page_no, searchText, selectedPriority, selectedAssignee, selectedSprint, selectedSuspicious = '1',selectedFilter, selectedInactiveUser, viewType],
  onSuccess,
  onError = onDefaultError
) => {
  console.log('here task list type', viewType, !!id && Number(viewType) === 1);
  return useQuery(
    ['task-list', id, page_no, searchText, selectedPriority, selectedAssignee, selectedSprint, selectedSuspicious, selectedFilter, selectedInactiveUser],
    () =>
      TaskService.listTask({
        id,
        page_no,
        searchText,
        selectedPriority,
        selectedAssignee,
        selectedSprint,
        selectedFilter,
        selectedInactiveUser,
        selectedSuspicious,
      }),
    {
      onSuccess,
      keepPreviousData: true,
      onError,
      enabled: Number(viewType) === 1,
    }
  );
};
// Remove
const useDeleteTask = () => {
  const deleteTask = async (projectId, id) => {
    return await TaskService.deleteTask(projectId, id);
  };
  return { deleteTask };
};
// Add
const useAddTask = (onSuccess, onError = onDefaultError) => {
  return useMutation(TaskService.addTask, {
    onSuccess,
    onError
  });
};
// Update
const useUpdateTask = (onSuccess, onError = onDefaultError) => {
  return useMutation(TaskService.updateTask, {
    onSuccess,
    onError
  });
};
// Get Details
const useEditTask = (projectId, id, onSuccess, onError = onDefaultError) => {
  return useQuery('task-edit', () => TaskService.viewTask(projectId, id), {
    onSuccess,
    onError
  });
};

const useShowTask = (projectId, id, onSuccess, onError = onDefaultError) => {
  return useQuery('task-show', () => TaskService.showTask(projectId, id), {
    onSuccess,
    onError
  });
};

// Get Task Status Types
const useGetTaskStatusTypes = (projectId, onSuccess, onError = onDefaultError) => {
  return useQuery('task-status-type', () => TaskService.getTaskStatusTypes(projectId), {
    onSuccess,
    onError
  });
};
// Get Sprint List
const useGetSprintList = (projectId, onSuccess, onError = onDefaultError) => {
  return useQuery('sprint-list', () => TaskService.getSprintList(projectId), {
    onSuccess,
    onError
  });
};
// Get Task Priorities
const useGetTaskPriorities = (onSuccess, onError = onDefaultError) => {
  return useQuery('task-priority-list', TaskService.getTaskPriorities, {
    onSuccess,
    onError
  });
};
// Get Task Details
const useGetTaskDetails = (projectId, id, onSuccess, onError = onDefaultError) => {
  return useQuery('task-details', () => TaskService.getTaskDetails(projectId, id), {
    onSuccess,
    onError
  });
};
// Get Employee List
const useGetAssignedProjectEmployeeList = (
  projectId,
  status = 0,
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    'task-employee-list',
    () => TaskService.getAssignedProjectEmployeeList(projectId, status),
    {
      onSuccess,
      onError
    }
  );
};
// Update Assignees
const useUpdateAssignees = (onSuccess, onError = onDefaultError) => {
  return useMutation(TaskService.updateTaskAssignees, {
    onSuccess,
    onError
  });
};
// Get Task Status Types With Sub Tasks
const useGetTaskStatusTypesWithSubTasks = (
  [id, searchText, selectedPriority, selectedAssignee, selectedSprint, selectedSuspicious = '1', selectedFilter, selectedInactiveUser, viewType],
  onSuccess,
  onError = onDefaultError
) => {
  console.log('here sub task view type', viewType, !!id && Number(viewType) === 2);
  return useQuery(
    ['task-sub-list', id, searchText, selectedPriority, selectedAssignee, selectedSprint, selectedSuspicious, selectedFilter, selectedInactiveUser],
    () =>
      TaskService.getTaskStatusTypesWithSubTasks({
        id,
        searchText,
        selectedPriority,
        selectedAssignee,
        selectedSprint,
        selectedSuspicious,
        selectedFilter,
        selectedInactiveUser
      }),
    {
      onSuccess,
      keepPreviousData: true,
      onError,
      enabled: !!id && Number(viewType) === 2,
    }
  );
};
// Update Task Status
const useUpdateTaskStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(TaskService.updateTaskStatus, {
    onSuccess,
    onError
  });
};
// Update Task Status
const useUpdateTaskPriority = (onSuccess, onError = onDefaultError) => {
  return useMutation(TaskService.updateTaskPriority, {
    onSuccess,
    onError
  });
};
// Get Employee List
const useGetAssignedProjectEmployeeAdminList = (
  projectId,
  status = 0,
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    'task-employee-admin-list',
    () => TaskService.getAssignedProjectEmployeeAdminList(projectId, status),
    {
      onSuccess,
      onError
    }
  );
};
const useGetProjectRemovedInactiveProjectEmployeeList = (
  projectId,
  viewType = 0,
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    'task-inactive-employee-list',
    () => TaskService.getProjectRemovedInactiveProjectEmployeeList(projectId, viewType),
    {
      onSuccess,
      onError
    }
  );
};
const useGetProjectRemovedInactiveHistroyEmployeeList  = (
  projectId,
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    'task-inactive-history-employee-list',
    () => TaskService.getProjectRemovedInactiveHistoryEmployeeList(projectId),
    {
      onSuccess,
      onError
    }
  );
};
export {
  useDeleteTask,
  useListTask,
  useAddTask,
  useUpdateTask,
  useEditTask,
  useGetTaskStatusTypes,
  useGetSprintList,
  useGetTaskPriorities,
  useGetTaskDetails,
  useGetAssignedProjectEmployeeList,
  useGetProjectRemovedInactiveProjectEmployeeList,
  useGetProjectRemovedInactiveHistroyEmployeeList,
  useGetAssignedProjectEmployeeAdminList,
  useUpdateAssignees,
  useGetTaskStatusTypesWithSubTasks,
  useUpdateTaskStatus,
  useUpdateTaskPriority,
  useShowTask
};
